import React from "react";
import { Pencil } from "lucide-react";
import { Button } from "../ui/button";
import DocumentPrintPdfActions from "../DocumentPrintPdfActions";

const PATH_PREFIX = {
  truck: "/lab-reports",
  composite: "/composite-lab-reports",
  stack: "/stack-sample-lab-reports",
  plant: "/plant-lab-reports",
};

export default function LabReportReceiptActions({
  reportId,
  kind = "truck",
  label,
  compact = true,
  onEdit,
  canEdit = false,
}) {
  const base = PATH_PREFIX[kind] || PATH_PREFIX.truck;
  const safeLabel = (label || `${kind}-${reportId}`).replace(/[/\\?%*:|"<>]/g, "-");

  return (
    <div className="flex items-center justify-end gap-0.5 shrink-0" onClick={(e) => e.stopPropagation()}>
      <DocumentPrintPdfActions
        printPath={`${base}/${reportId}/receipt/print`}
        pdfPath={`${base}/${reportId}/receipt/pdf`}
        pdfFilename={`${kind}-lab-${safeLabel}.pdf`}
        compact={compact}
        printTitle="Print lab report"
        pdfTitle="Download lab report PDF"
        testIdPrefix={`${kind}-lab-${reportId}`}
        stopPropagation
      />
      {canEdit && onEdit && (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="h-8 w-8 shrink-0 text-muted-foreground hover:text-foreground"
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
          title="Edit report"
          aria-label="Edit report"
          data-testid={`edit-${kind}-lab-${reportId}`}
        >
          <Pencil className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
